import { checkboxAnatomy } from '@chakra-ui/anatomy'
import { createMultiStyleConfigHelpers, defineStyle } from '@chakra-ui/react'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys)

const {
  Button: {
    FocusVisible: { BoxShadow: BoxShadowColor },
  },
} = themeColorSectionKeys.defaults

const baseStyle = definePartsStyle({
  // define the part you're going to style
  label: {
    textStyle: textStyleKeys.Body1,
  },
  control: {
    padding: 0,
    borderRadius: '0.188rem',
    borderWidth: 0,
    backgroundColor: 'transparent',
    boxShadow: 'none',
    _active: {
      boxShadow: 'none',
    },
    _focus: {
      boxShadow: 'none',
    },
    _focusVisible: {
      boxShadow: `${asChakraVariable(BoxShadowColor)} 0px 0px 0px 2px`,
    },
  },
})

const sizes = {
  lg: definePartsStyle({
    control: defineStyle({
      boxSize: '1.5rem',
    }),
    label: defineStyle({
      textStyle: textStyleKeys.Body1,
      marginLeft: '0.5rem',
    }),
  }),
}

export const CheckboxStyle = defineMultiStyleConfig({ baseStyle, sizes })
